import { useEffect } from 'react'
import type { Agent } from '@/entities/agent/types/types'

interface UseAgentDataLoggerParams {
  agentData: Agent | null
  agentId: string | undefined
}

/**
 * Agent 데이터 로딩 상태 로깅 Hook
 *
 * 책임:
 * - Agent 데이터 로딩 완료 시 로깅
 * - 디버깅용 정보 출력
 */
export const useAgentDataLogger = ({
  agentData,
  agentId,
}: UseAgentDataLoggerParams) => {
  useEffect(() => {
    if (agentData) {
      console.log('✅ Agent data loaded:', {
        agentId: agentData.id,
        name: agentData.name,
        description: agentData.description,
      })
    }
  }, [agentData, agentId])
}
